<template>
    <div v-if="name">
        <p>
            <strong>{{name}}</strong><br>
            {{address}}, {{city}} {{zip}}<br>
            IČ: {{identificationNumber}}<br>
            DIČ: {{taxIdentificationNumber}}
        </p>
        <button class="button button--link" v-on:click="displayFullFormControl()">
            Upravit údaje
        </button>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';

    export default {
        name:     'SsvOrderBillingInformationInfo',
        props:    {
            displayFullForm: {
                type:    Boolean,
                default: false,
            }
        },
        computed: {
            ...mapFields('ssvOrder', [
                'billingInformation.name',
                'billingInformation.address',
                'billingInformation.zip',
                'billingInformation.city',
                'billingInformation.identificationNumber',
                'billingInformation.taxIdentificationNumber',
            ]),
        },
        methods:  {
            displayFullFormControl() {
                this.$emit('displayFullFormControl');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/billing-information/BillingInformationInfo.vue